import React from 'react';
import { useParams } from 'react-router-dom';
import './RecruitmentHostPage.css';

export default function RecruitmentHostPage() {
  const { workspaceId } = useParams();
  const src = `/recruitment/workspaces/${encodeURIComponent(workspaceId)}/recruitment?embed=1`;

  return (
    <div className="v-recruitment-host v-recruitment-host--embedded" role="region" aria-label="Recruitment">
      <iframe
        title="Recruitment"
        className="v-recruitment-host__frame"
        src={src}
      />
    </div>
  );
}
